// @dynamic
/**
 * @dynamic need this because there are static memebers
 *
 * Email constants
 */

export class EmailValidationMessagesConstants {

  /**
   * Constant for email pattern
   */
  public static readonly PATTERN: string = 'Enter a valid email';

  /**
   * Constant for email required
   */
  public static readonly REQUIRED: string = 'Email is required';

}
